module.exports = __webpack_public_path__ + "img/del-hover.d6f6f619.svg";